import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const SuccessIcon = () => (
	<span className='flex h-6 w-6 items-center justify-center rounded-[10px] bg-[#D7FB36] text-[#111111]'>
		<svg
			width='15'
			height='15'
			viewBox='0 0 15 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden='true'>
			<path
				d='M12.25 4.25L6.45 10.05L3 6.6'
				stroke='#111111'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	</span>
)

const ErrorIcon = () => (
	<span className='flex h-6 w-6 items-center justify-center rounded-[10px] bg-[#FDEBEC] text-[#9F2F2D]'>
		<svg
			width='15'
			height='15'
			viewBox='0 0 15 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden='true'>
			<path
				d='M7.5 3.35V7.75'
				stroke='#9F2F2D'
				strokeWidth='2'
				strokeLinecap='round'
			/>
			<path
				d='M7.5 11.45H7.51'
				stroke='#9F2F2D'
				strokeWidth='2.4'
				strokeLinecap='round'
			/>
		</svg>
	</span>
)

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = 'system' } = useTheme()

	return (
		<Sonner
			theme={theme as ToasterProps['theme']}
			className='toaster group'
			duration={3200}
			gap={10}
			icons={{
				success: <SuccessIcon />,
				error: <ErrorIcon />,
			}}
			toastOptions={{
				classNames: {
					toast:
						'group toast !min-h-[52px] !rounded-[18px] !border !border-[#EAEAEA] !bg-white !px-4 !py-3 !text-[#111111] !shadow-[0_8px_26px_rgba(17,17,17,0.04)]',
					title: '!text-[14px] !font-semibold !leading-[1.25] !tracking-[-0.01em] !text-[#111111]',
					success: '!border-[#D7FB36]',
					error: '!border-[#FDEBEC]',
					icon: '!mr-2 !h-6 !w-6',
					description:
						'!mt-1 !text-[12px] !leading-[1.35] !text-[#787774]',
					actionButton: '!rounded-[10px] !bg-[#111111] !px-3 !text-white',
					cancelButton:
						'!rounded-[10px] !bg-[#F7F6F3] !px-3 !text-[#787774]',
				},
			}}
			{...props}
		/>
	)
}

export { Toaster }
